import React from 'react';
import usePreflightTest from './usePreflightTest/usePreflightTest';
import { makeStyles, Typography, Grid } from '@material-ui/core';
import useGetPreflightTokens from './useGetPreflightTokens/useGetPreflightTokens';
import getNetworkCondition from './getNetworkCondition/getNetworkCondition';
import ProgressIndicator from './ProgressIndicator/ProgressIndicator';
import { SuccessIcon } from '../../../icons/SuccessIcon';
import WarningIcon from '../../../icons/WarningIcon';
import ErrorIcon from '../../../icons/ErrorIcon';

export const TEST_DURATION = 10000;

export enum NetworkCondition {
  Red,
  Yellow,
  Green,
}

const useStyles = makeStyles({
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '0.4em',
  },
  result: {
    color: 'white',
  },
});

function ResultItem({ children, icon }: { children: React.ReactNode; icon: React.ReactNode }) {
  const classes = useStyles();

  return (
    <>
      <div className={classes.iconContainer}>{icon}</div>
      <Typography variant="subtitle2" className={classes.result}>
        {children}
      </Typography>
    </>
  );
}

export function Result({ networkCondition, error }: { networkCondition?: NetworkCondition; error?: Error }) {
  if (error) {
    return <ResultItem icon={<ErrorIcon />}>Tem um problema ao conectar com a rede</ResultItem>;
  }

  if (networkCondition === NetworkCondition.Red) {
    return (
      <ResultItem icon={<ErrorIcon />}>
        Conexão ruim. Você poderá experienciar uma qualidade baixa na chamada.
      </ResultItem>
    );
  }

  if (networkCondition === NetworkCondition.Yellow) {
    return (
      <ResultItem icon={<WarningIcon />}>
        Conexão ruim. Você poderá experienciar uma performance de video inferior.
      </ResultItem>
    );
  }

  if (networkCondition === NetworkCondition.Green) {
    return <ResultItem icon={<SuccessIcon />}>Sua conexão com a rede esta estável</ResultItem>;
  }

  return null;
}

export default function PreflightTest() {
  const classes = useStyles();

  const { tokens, tokenError } = useGetPreflightTokens();
  const { testFailure, testReport } = usePreflightTest(tokens?.[0], tokens?.[1]);

  const networkCondition = getNetworkCondition(testReport);

  return (
    <Grid container justify="center" alignItems="center" style={{ height: '55px', paddingBottom: '1.5em' }}>
      {!testFailure && !testReport ? (
        <>
          <ProgressIndicator />
          <Typography variant="subtitle2" className={classes.result}>
            Checando sua conexão com a rede
          </Typography>
        </>
      ) : (
        <Result networkCondition={networkCondition} error={tokenError || testFailure} />
      )}
    </Grid>
  );
}
